import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate } from "remotion";

// 效果 10: 旋转过渡
export const RotateTransition: React.FC = () => {
  const frame = useCurrentFrame();
  const rotation = interpolate(frame, [0, 120], [0, 720], {
    extrapolateRight: "clamp",
  });
  const opacity = interpolate(
    frame,
    [0, 30, 90, 120],
    [0, 1, 1, 0],
    { extrapolateRight: "clamp" }
  );
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#0f0f23",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          fontSize: 80,
          color: "#ff6b6b",
          fontWeight: "bold",
          transform: `rotate(${rotation}deg)`,
          opacity,
        }}
      >
        Rotate
      </div>
    </AbsoluteFill>
  );
};

// 效果 12: 弹跳过渡
export const BounceTransition: React.FC = () => {
  const frame = useCurrentFrame();
  const y = interpolate(
    frame,
    [0, 15, 30, 45, 60, 75, 90, 105, 120],
    [-500, 100, -50, 25, -10, 5, 0, 0, 0],
    { extrapolateRight: "clamp" }
  );
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#1a1a2e",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          fontSize: 80,
          color: "#95e1d3",
          fontWeight: "bold",
          transform: `translateY(${y}px)`,
        }}
      >
        Bounce
      </div>
    </AbsoluteFill>
  );
};
